<template>
  <div :class="vertical ? 'mx-' + marginLevel : 'my-' + marginLevel ">
    <v-divider
      v-if="bold"
      class="line-border"
      :vertical="vertical"
      :style="{
        'width': vertical ? 'auto' : long,
        'height': vertical ? long : 'auto',
        'border': borderType,
        'border-color': borderColor,
        'border-width': borderWidth + 'px'
      }"
      style="border-radius: 10%"
    ></v-divider>
    <div
        v-else
        class="line-border"
        :style="{
        'width': vertical ? 'auto' : long,
        'height': vertical ? long : 'auto',
        'border-bottom': vertical ? 'none' : borderType + ' ' + borderWidth + 'px ' + borderColor,
        'border-right': vertical ? borderType + ' ' + borderWidth + 'px ' + borderColor + ' !important' : 'none'
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'Divider',
  props: {
    long: {
      default: '100%'
    },
    bold: {
      default: false
    },
    vertical: {
      default: false
    },
    borderWidth: {
      default: '1'
    },
    borderColor: {
      default: 'rgba(0,0,0,.12)'
    },
    borderType: {
      default: 'solid'
    },
    marginLevel: {
      default: '3'
    }
  }
}
</script>

<style scoped lang="scss">

</style>
